import { useEffect } from "react";
import * as S from '../Elements/ElementStyles';
import { Icon } from '@fluentui/react/lib/Icon';
import React from "react";

const ModalElementsIATransfer = ({setModalShow, okModal, errorMessage}: {setModalShow: any, okModal: boolean, errorMessage?: string}) =>
{
    const [height, setHeight] = React.useState('');

    useEffect(() =>
    {
        const toHeight = document?.querySelector('#root')?.scrollHeight + 'px';
        setHeight(toHeight);
    }, []);

    return(
        <React.Fragment>
            <S.HelperStyle />
            <S.ModalIAMainCont>
                <S.ModalToExitCont>
                    <S.ModalToExit>
                        <Icon iconName='ChromeClose'
                            // @ts-ignore
                            styles={closeBtn}
                            onClick={() => setModalShow(false)}
                        />
                    </S.ModalToExit>
                </S.ModalToExitCont>
                {okModal === true &&
                (
                    <React.Fragment>
                        <S.ModalContinue>
                            ¡Proceso de firma completado!
                        </S.ModalContinue>
                        <S.ModalNeedsCont>
                            <p>
                                Enhorabuena, has completado el reembolso de Elements IA.
                                Tendrás el reembolso en tu cuenta en aproximadamente 48 horas.
                            </p>
                        </S.ModalNeedsCont>
                    </React.Fragment>
                )}
                {okModal === false &&
                (
                    <React.Fragment>
                        <S.ModalContinue>
                            Ha habido un error al procesar la operación
                        </S.ModalContinue>
                        <S.ModalNeedsCont>
                            {errorMessage !== undefined &&
                            (
                                <React.Fragment>
                                    <p>
                                        {errorMessage}
                                    </p>
                                </React.Fragment>
                            )}
                            {errorMessage === undefined &&
                            (
                                <React.Fragment>
                                    <p>
                                        Se ha producido un error al procesar la operación de reembolso de Elements IA.
                                        Por favor, ponte en contacto con <a href="mailto:info@ironia.tech">info@ironia.tech</a> indicando la
                                        cantidad de Elements IA que deseas reembolsar.
                                    </p>
                                </React.Fragment>
                            )}
                        </S.ModalNeedsCont>
                    </React.Fragment>
                )}
                <S.ModalBtnCont>
                    <S.ModalLinkBtn to={'/ElementsIA'}>
                        <S.ModalAcceptBtn>Aceptar</S.ModalAcceptBtn>
                    </S.ModalLinkBtn>
                </S.ModalBtnCont>
            </S.ModalIAMainCont>
            <S.ModalFocus className='modal' // @ts-ignore
                height={height} />
        </React.Fragment>
    );
};

const closeBtn =
{
    root:
    {
        fontSize: "14px",
        fontWeight: 1000,
        position: "relative",
        color: "#BFC6C7",
    },
}

export default ModalElementsIATransfer;